import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ConfirmationComponent} from './pages/confirmation/confirmation.component';
import {EditUserComponent} from './pages/edit-user/edit-user.component';
import {InviteComponent} from './pages/invite/invite.component';
import {LoginByPhoneComponent} from './pages/login-by-phone/login-by-phone.component';
import {LoginComponent} from './pages/login/login.component';
import {RequestPasswordComponent} from './pages/request-password/request-password.component';
import {TermsAndConditionsComponent} from './pages/terms-and-conditions/terms-and-conditions.component';
import {AuthorizeGuard} from './repositories/authorize-guard.service';
import {ConfirmationGuardService} from './repositories/confirmation-guard.service';
import {NotAuhorizedGuardService} from './repositories/not-auhorized-guard.service';
import {ThankYouComponent} from './pages/thank-you/thank-you.component';
import {ThankYouWithoutDocumentsComponent} from './pages/thank-you-without-documents/thank-you-without-documents.component';

const routes: Routes = [
  {path: '', redirectTo: 'workspace', pathMatch: 'full'},
  {path: 'login', component: LoginComponent, canActivate: [NotAuhorizedGuardService]},
  {path: 'loginbyphone', component: LoginByPhoneComponent, canActivate: [NotAuhorizedGuardService]},
  {path: 'confirmation', component: ConfirmationComponent, canActivate: [ConfirmationGuardService]},
  {path: 'edituser', component: EditUserComponent, canActivate: [NotAuhorizedGuardService]},
  {path: 'thank-you', component: ThankYouComponent, canActivate: [AuthorizeGuard]},
  {path: 'thank-you-without-documents', component: ThankYouWithoutDocumentsComponent, canActivate: [AuthorizeGuard]},
  {path: 'terms', component: TermsAndConditionsComponent, canActivate: [AuthorizeGuard]},
  {path: 'getpass', component: RequestPasswordComponent},
  {path: 'partner', component: InviteComponent}

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
